var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 442,
    height: 443,
    viewBox: "0 0 442 443",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.998 110.304C220.678 49.551 171.329 0.400024 110.5 0.400024C49.4725 0.400024 0 49.8726 0 110.9C0 171.729 49.1509 221.078 109.904 221.398V221.402C49.1509 221.722 0 271.071 0 331.9C0 392.927 49.4725 442.4 110.5 442.4C171.527 442.4 221 392.927 221 331.9C221 392.927 270.473 442.4 331.5 442.4C392.528 442.4 442 392.927 442 331.9C442 270.873 392.528 221.4 331.5 221.4C392.528 221.4 442 171.927 442 110.9C442 49.8726 392.528 0.400024 331.5 0.400024C270.671 0.400024 221.322 49.5509 221.002 110.304H220.998ZM330.901 221.402V221.398C331.101 221.399 331.3 221.4 331.5 221.4C331.3 221.4 331.101 221.401 330.901 221.402ZM221.002 331.301C221.001 331.501 221 331.7 221 331.9C221 331.7 220.999 331.501 220.998 331.301H221.002Z",
    fill: "url(#paint0_linear_39_1221)",
    fillOpacity: 0.12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_1221",
    x1: 221,
    y1: 0.400024,
    x2: 221,
    y2: 442.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D100FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99DFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBackground);
export default __webpack_public_path__ + "static/media/profile_background.c82b323f167f44360ba296b77a4a4234.svg";
export { ForwardRef as ReactComponent };